import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { api } from '../../../static/api';
import { ApiAddQuestionRequest } from '../../../types/ApiTypes';
import { QueryAliases } from '../../../types/QueryAliases';
import { getApiErrorMessage } from '../../../utils/api/getApiErrorMessage';
import useAxiosInstance from '../../axios/useAxiosInstance';
import useToast from '../../useToast';

const useCreateQuestion = () => {
  const axiosInstance = useAxiosInstance();
  const { t } = useTranslation();
  const { showErrorToast } = useToast();
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation(
    (data: ApiAddQuestionRequest) => axiosInstance.post(api.endpoints.QUESTIONS, { ...data }),
    {
      async onSuccess() {
        await queryClient.refetchQueries([QueryAliases.QUESTIONS]);
      },
      onError: (err: AxiosError) => {
        const errorMessage = getApiErrorMessage(err) ?? t('errorMessages.addQuestionFailed');

        showErrorToast(errorMessage);
      },
    },
  );

  return { createQuestion: mutateAsync, isLoading };
};

export default useCreateQuestion;
